import React from 'react'
import LoadingCircle from "../assets/loading-circle.gif";

function Loader() {
    return <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "70vh" }}
    >
        <img src={LoadingCircle} alt="loading-circle" />
    </div>
}

export default Loader